import { useEffect, useMemo } from 'react';
import CrossTabConfig from 'worker-connection-library/calling-cross-tab-utils/CrossTabConfig';
import { addBroadcastMessageHandler, removeBroadcastMessageHandler } from 'worker-connection-library/calling-cross-tab-utils/broadcastMessageHandler';
import { OPEN_WIDGET, REMOTE_OPENED, DUPLICATE_POPUP_OPENED, UPDATE_CALL_PROVIDER, REFRESH_REQUEST, REMOTE_OPENED_ACK, POPUP_OPENED, POPUP_CLOSED, HEARTBEAT_REQUEST, HEARTBEAT_RESPONSE, INITIATE_OUTBOUND_CALL, isFromPopupEvent, isBroadcastEvent } from '../types/BroadcastEvents';
import { logDebugMessage } from '../utils/logDebugMessage';
export const REMOTE = 'remote';
export const WINDOW = 'window';
export function useBroadcastEventHandler({
  onOpenWidget,
  onRemoteOpened,
  onRemoteOpenedAck,
  onDuplicatePopupOpened,
  onUpdateCallProvider,
  onRefreshRequest,
  onPopupOpened,
  onPopupClosed,
  onHeartbeatRequest,
  onHeartbeatResponse,
  onInitiateOutboundCall
}) {
  const handlers = useMemo(() => {
    return {
      [OPEN_WIDGET]: onOpenWidget,
      [REMOTE_OPENED]: onRemoteOpened,
      [REMOTE_OPENED_ACK]: onRemoteOpenedAck,
      [DUPLICATE_POPUP_OPENED]: onDuplicatePopupOpened,
      [UPDATE_CALL_PROVIDER]: onUpdateCallProvider,
      [REFRESH_REQUEST]: onRefreshRequest,
      [POPUP_OPENED]: onPopupOpened,
      [POPUP_CLOSED]: onPopupClosed,
      [HEARTBEAT_REQUEST]: onHeartbeatRequest,
      [HEARTBEAT_RESPONSE]: onHeartbeatResponse,
      [INITIATE_OUTBOUND_CALL]: onInitiateOutboundCall
    };
  }, [onUpdateCallProvider, onOpenWidget, onRemoteOpened, onDuplicatePopupOpened, onRefreshRequest, onRemoteOpenedAck, onPopupOpened, onPopupClosed, onHeartbeatRequest, onHeartbeatResponse, onInitiateOutboundCall]);
  useEffect(() => {
    const handleOnReceiveMessageFromHost = message => {
      if (!isBroadcastEvent(message.type)) {
        return;
      }
      const eventHandler = handlers[message.type];
      if (typeof eventHandler === 'function') {
        // Ignore messages from self
        if (message.originConnectionId === CrossTabConfig.get().connectionId) {
          return;
        }
        eventHandler(message);
        const host = isFromPopupEvent(message.type) ? WINDOW : REMOTE;
        logDebugMessage(`Received message from ${host}`, message);
      }
    };
    addBroadcastMessageHandler(handleOnReceiveMessageFromHost);
    return () => {
      removeBroadcastMessageHandler(handleOnReceiveMessageFromHost);
    };
  }, [handlers]);
}